import React, { Component } from 'react'
import _ from 'lodash'

class ContentScroller extends Component {

    constructor(props) {
        super(props)

        this.scrollRef = element => {
            this.scrollElementRef = element
        }
    }

    resetScroll() {
        this.scrollElementRef.scrollLeft = 0
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(this.props.children, prevProps.children)) {
            this.resetScroll()
        }
    }

    render() {
        const { children, isCentered } = this.props
        return (
            <div className={`c-content-scroller ${isCentered ? 'c-content-scroller--centered' : ''}`} ref={this.scrollRef}>
                {children}
            </div>
        )
    }
}

export default ContentScroller


// WEBPACK FOOTER //
// ./src/components/ContentScroller.js